import { useEffect } from "react"

import styled from "styled-components"
import { NextSeo } from "next-seo"
import type { GetStaticPropsContext, InferGetStaticPropsType } from "next"

import { getSite } from "@lib/site"
import { getDictionary } from "@lib/dictionary"

import { useTracking } from "@hooks/index"

import { RichText } from "@components/common"
import { AuthContainer, AccountNav } from "@components/account"

export default function Rewards({
  site,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  const { trackPage } = useTracking()

  useEffect(() => {
    trackPage({ type: "Account" })
  }, [])
  return (
    <>
      <NextSeo title="Rewards" />
      <AuthContainer>
        <Body>
          <AccountNav />
          <HeaderWrapper>
            <RichText richText={site.rewardsPageHeader} />
          </HeaderWrapper>
        </Body>
      </AuthContainer>
    </>
  )
}

const Body = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 14rem;

  @media (min-width: ${({ theme }) => theme.breakpoint.md}px) {
    margin: 0 0 15rem;
    flex-direction: row;
    justify-content: space-between;
    padding: 7.2rem 12rem 7rem 9rem;
  }
`

const HeaderWrapper = styled.div`
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-weight: 300;
  }

  p {
    font-size: 1.5rem;
    line-height: 3rem;
  }
`

export async function getStaticProps({
  preview = false,
  locale = "en-US",
}: GetStaticPropsContext) {
  const site = await getSite({ preview, locale })
  const dictionary = await getDictionary({ preview, locale })

  return {
    props: {
      site,
      dictionary,
      isAccountPage: true,
      locale,
    },
  }
}
